<template>
  <div class="login-page">
    <div class="card login-card">
      <img src="@/assets/logo_igreja.png" alt="Nova Aliança El Shaday" class="logo" />
      <h1>Painel de Inscrições</h1>
      <p class="sub">Nova Aliança El Shaday</p>
      <form @submit.prevent="handleLogin" class="form">
        <div class="form-row">
          <label class="label">E-mail</label>
          <input class="input" type="email" v-model="email" required autofocus />
        </div>
        <div class="form-row">
          <label class="label">Senha</label>
          <input class="input" type="password" v-model="password" required />
        </div>
        <div v-if="error" class="error-msg">{{ error }}</div>
        <button class="btn-primary btn-submit" type="submit" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '../../stores/auth'

export default {
  name: 'LoginPage',
  data() { return { email: '', password: '', loading: false, error: '' } },
  computed: { authStore() { return useAuthStore() } },
  methods: {
    async handleLogin() {
      this.loading = true
      this.error = ''
      try {
        await this.authStore.login(this.email, this.password)
        this.$router.push('/admin')
      } catch (err) {
        this.error = err.response?.data?.message || 'Falha ao entrar.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  padding: var(--spacing-base);
  background: linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%);
}
.login-card {
  width: 100%; max-width: 380px;
  padding: var(--spacing-xl);
  display: flex; flex-direction: column; gap: var(--spacing-md);
  align-items: stretch;
}
.logo {
  width: 84px; height: 84px;
  margin: 0 auto;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}
h1 { font-size: var(--text-xl); text-align: center; margin-top: var(--spacing-xs); }
.sub { text-align: center; color: var(--color-text-muted); font-size: var(--text-sm); margin-bottom: var(--spacing-md); }
.form { display: flex; flex-direction: column; gap: var(--spacing-md); }
.form-row { display: flex; flex-direction: column; gap: 4px; }
.btn-submit { margin-top: var(--spacing-sm); padding: 12px; }
</style>
